export default __webpack_public_path__ + "static/media/biometry.e9ceb958.png";